import { basicInitialState } from '../_utils/basicInitialState';
import { TUserGroupsState } from './userGroupsModel';

export const userGroupsInitialState: TUserGroupsState = {
  ...basicInitialState,
  searchText: '',
  groups: []
};
